import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class EinvoiceEwaybillServices {
  /**
     * @param {*} payload
     * @return
     */
       enableEinvoiceEwaybill = async (payload) => {
         const url = `${Constants.ENABLE_EWAY_BILL}`;
         const EinvoiceEwaybills = await Helpers.post({
           url,
           data: payload,
         });
         return EinvoiceEwaybills;
       }

   GSTAuthentication = async (payload) => {
     const url = `${Constants.AUTH_GST_SUVIDHA}`;
     const deauthentication = await Helpers.post({
       url,
       data: payload,
     });
     return deauthentication;
   }

     GSTDeauthentication = async (payload) => {
       const url = `${Constants.DEACTIVATE_GST_SUVIDHA}`;
       const authentication = await Helpers.post({
         url,
         data: payload,
       });
       return authentication;
     }

   pushIRP = async (payload) => {
     const url = `${Constants.PUSH_IRP}`;
     const pushIRP = await Helpers.post({
       url,
       data: payload,
     });
     return pushIRP;
   }

   pushCnToIRP = async (payload) => {
     const url = `${Constants.PUSH_CN_TO_IRP}`;
     const pushIRP = await Helpers.post({
       url,
       data: payload,
     });
     return pushIRP;
   }

     genEwaybill = async (payload) => {
       const url = `${Constants.GEN_EWAY_BILL}`;
       const ewaybill = await Helpers.post({
         url,
         data: payload,
       });
       return ewaybill;
     }

  getEwaybills = async (page, limit, keyword, tenantId, doctype, status, fromDate, toDate) => {
    let url = `${Constants.GET_EWAY_BILLS}?`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (keyword) url += `search_keyword=${keyword}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (doctype) url += `doc_type=${doctype}&`;
    if (status) url += `status=${status}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;

    const ewaybills = await Helpers.get({ url });
    return ewaybills;
  }

  cancelIRP = async (payload) => {
    const url = `${Constants.CANCEL_IRP}`;
    const cancelIRP = await Helpers.post({
      url,
      data: payload,
    });
    return cancelIRP;
  }

    cancelEwaybill = async (payload) => {
      const url = `${Constants.CANCEL_EWAY_BILL}`;
      const cancelewb = await Helpers.post({
        url,
        data: payload,
      });
      return cancelewb;
    }

      addTransporter = async (payload) => {
        const url = `${Constants.ADD_TRANSPORTATION}`;
        const transport = await Helpers.post({
          url,
          data: payload,
        });
        return transport;
      }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  excludeEwayBills = async (payload) => {
    const url = `${Constants.EXCLUDE_EWAY_BILLS}`;
    const excludedBills = await Helpers.post({
      url,
      data: payload,
    });
    return excludedBills;
  }

  fetchEwayBill = async (payload) => {
    const url = `${Constants.FETCH_EWAY_BILL}`;
    const excludedBill = await Helpers.post({
      url,
      data: payload,
    });
    return excludedBill;
  }
}
export default new EinvoiceEwaybillServices();
